import {
  drawerWidth,
  transition,
  container,
  primaryColor,
  dangerColor,
  successColor,
  defaultFont,
  warningColor,
  roseColor,
  infoColor
} from "../material-dashboard-react"
import tooltipStyle from "../tooltipStyle"
const appStyle = theme => ({
  ...tooltipStyle,
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh"
  },
  painel: {
    height: "100%",
    overflow: "auto"
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch"
  },
  content: {
    alignItems: "center",
    marginTop: "70px",
    padding: "30px 15px",
    minHeight: "calc(100vh - 123px)"
  },
  container,
  map: {
    marginTop: "70px"
  },
  textCent: {
    justifyContent: "center"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "10px",
    minHeight: "auto",
    fontWeight: "500",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  cardTitleGray: {
    color: "#515151",
    marginTop: "10px",
    minHeight: "auto",
    fontWeight: "500",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  dotWarning: {
    color: "#FFAB2E"
  },
  tableWrapper: {
    overflowX: "auto"
  },
  edit: {
    backgroundColor: "transparent",
    color: primaryColor,
    boxShadow: "none"
  },
  print: {
    backgroundColor: "transparent",
    color: primaryColor,
    boxShadow: "none"
  },
  book: {
    backgroundColor: "transparent",
    color: warningColor,
    boxShadow: "none"
  },
  ficha: {
    backgroundColor: "transparent",
    color: roseColor,
    boxShadow: "none"
  },
  close: {
    backgroundColor: "transparent",
    color: dangerColor,
    boxShadow: "none"
  },
  debitos: {
    backgroundColor: "transparent",
    color: infoColor,
    boxShadow: "none"
  },
  tableActions: {
    display: "flex",
    border: "none",
    padding: "12px 8px !important",
    verticalAlign: "middle"
  },
  tableCell: {
    ...defaultFont,
    padding: "8px",
    border: "none",
    verticalAlign: "middle",
    lineHeight: "1.42857143",
    fontSize: "14px"
  },
  tableActionButton: {
    width: "27px",
    height: "27px",
    padding: "0"
  },
  tableActionButtonIcon: {
    width: "17px",
    height: "17px"
  },
  tableRow: {
    position: "relative",
    borderBottom: "1px solid #dddddd"
  },
  tableHeadCell: {
    color: "inherit",
    ...defaultFont,
    fontSize: "1em"
  },
  legend: {
    margin: "10px 0"
  },
  dot: {
    margin: "0 10px"
  },
  dotSuccess: {
    color: successColor
  },
  dotDanger: {
    color: dangerColor
  }
})

export default appStyle
